@use '@fukuri-admins/ui/layout' as *;


// Popover Content Styles
.popoverContent {
  z-index: 9999;
  transform: var(--radix-popover-content-transform-origin);

  // Animation states
  &[data-state="open"] {
    animation: fadeIn 0.2s ease-out, zoomIn 0.2s ease-out;
    
    &[data-side="bottom"] {
      animation: fadeIn 0.2s ease-out, zoomIn 0.2s ease-out, slideInFromTop 0.2s ease-out;
    }
    
    &[data-side="left"] {
      animation: fadeIn 0.2s ease-out, zoomIn 0.2s ease-out, slideInFromRight 0.2s ease-out;
    }
    
    &[data-side="right"] {
      animation: fadeIn 0.2s ease-out, zoomIn 0.2s ease-out, slideInFromLeft 0.2s ease-out;
    }
    
    &[data-side="top"] {
      animation: fadeIn 0.2s ease-out, zoomIn 0.2s ease-out, slideInFromBottom 0.2s ease-out;
    }
  }

  &[data-state="closed"] {
    animation: fadeOut 0.15s ease-in, zoomOut 0.15s ease-in;
  }
}

// Animation keyframes
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes zoomIn {
  from {
    transform: scale(0.95);
  }
  to {
    transform: scale(1);
  }
}

@keyframes zoomOut {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(0.95);
  }
}

@keyframes slideInFromTop {
  from {
    transform: translateY(-0.5rem);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slideInFromRight {
  from {
    transform: translateX(0.5rem);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes slideInFromLeft {
  from {
    transform: translateX(-0.5rem);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes slideInFromBottom {
  from {
    transform: translateY(0.5rem);
  }
  to {
    transform: translateY(0);
  }
}

.datePickerTrigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 224px;
  min-height: 40px;
  background: background('Primary');
  border-radius: borderRadius('lg');
  border: 1px solid border('Quaternary');
  padding: spacing('8') spacing('12');

  color: text('High');
  cursor: pointer;

  .datePickerTriggerText {
    @include typography('Jp/14_W3');
  }

  &:hover:not(:disabled) {
    background: background('Overlay_Bl_5');
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px border('Focus');
  }

  &:disabled {
    color: text('Disabled');
    cursor: not-allowed;
  }
}
